import { render, staticRenderFns } from "./Custas.vue?vue&type=template&id=9f051ca4&"
import script from "./Custas.vue?vue&type=script&lang=js&"
export * from "./Custas.vue?vue&type=script&lang=js&"
import style0 from "./Custas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports